/* South Snow - movimento da marca (Marca Integral, 09/2026)
   Tres coisas, nada alem disso:
   1. entrada suave das secoes ao rolar
   2. o numero da prova social contando ate o valor real
   3. a barra de reserva do celular, que aparece depois do hero
   Tudo desligado quando o visitante pede menos movimento. */
(function () {
  'use strict';

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. entrada suave -------------------------------------------------- */
  function revelar() {
    var alvos = document.querySelectorAll('.mi-revela:not(.is-visivel)');
    if (!alvos.length) return;

    if (quieto || !('IntersectionObserver' in window)) {
      for (var i = 0; i < alvos.length; i++) alvos[i].classList.add('is-visivel');
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        // escalona os irmaos para a secao entrar em cascata, nao em bloco
        var irmaos = el.parentElement ? el.parentElement.querySelectorAll(':scope > .mi-revela') : [];
        var pos = Array.prototype.indexOf.call(irmaos, el);
        el.style.setProperty('--mi-atraso', (pos > 0 ? Math.min(pos, 6) * 70 : 0) + 'ms');
        el.classList.add('is-visivel');
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    for (var j = 0; j < alvos.length; j++) obs.observe(alvos[j]);
  }

  /* 2. o numero da prova ---------------------------------------------- */
  function formatar(n) { return '+' + String(n).replace(/B(?=(d{3})+(?!d))/g, '.'); }

  function contar(el) {
    var alvo = parseInt(el.getAttribute('data-mi-conta'), 10);
    if (!alvo || quieto) { el.textContent = formatar(alvo || 0); return; }

    var dur = 1100, t0 = null;
    function passo(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var suave = 1 - Math.pow(1 - p, 3);
      el.textContent = formatar(Math.round(alvo * suave));
      if (p < 1) requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  }

  function ligarContadores() {
    var nums = document.querySelectorAll('[data-mi-conta]');
    if (!nums.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nums.length; i++) contar(nums[i]);
      return;
    }
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        contar(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    for (var j = 0; j < nums.length; j++) obs.observe(nums[j]);
  }

  /* 3. barra de reserva no celular ------------------------------------ */
  function ligarBarra() {
    var barra = document.querySelector('.mi-barra-fixa');
    var gatilho = document.querySelector('[data-mi-gatilho-barra]') || document.querySelector('.mi-hero');
    if (!barra || !gatilho || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (es) {
      // aparece quando o hero saiu da tela; some quando ele volta
      barra.classList.toggle('is-visivel', !es[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(gatilho);
  }

  function iniciar() { revelar(); ligarContadores(); ligarBarra(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  // o editor de tema troca secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', iniciar);
})();
